var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11191",
    "data-name": "Group 11191",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11190",
    "data-name": "Group 11190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16676",
    "data-name": "Path 16676",
    d: "M452.332,152.664a.332.332,0,1,0-.235-.1A.334.334,0,0,0,452.332,152.664Z",
    transform: "translate(-436.992 -146.953)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16677",
    "data-name": "Path 16677",
    d: "M16,1.328H14.867v-.2a1.129,1.129,0,0,0-2.258,0v.2H9.625v-.2a1.129,1.129,0,1,0-2.258,0v.2H4.383v-.2a1.129,1.129,0,0,0-2.258,0v.2H1a1,1,0,0,0-1,1V16a1,1,0,0,0,1,1H13.334a.331.331,0,0,0,.235-.1h0L16.9,13.569a.331.331,0,0,0,.1-.235V2.324A1,1,0,0,0,16,1.328Zm-2.731-.2a.465.465,0,0,1,.93,0V2.756a.465.465,0,0,1-.93,0Zm-5.242,0a.465.465,0,1,1,.93,0V2.756a.465.465,0,0,1-.93,0Zm-5.242,0a.465.465,0,0,1,.93,0V2.756a.465.465,0,0,1-.93,0ZM13.666,15.866V14A.332.332,0,0,1,14,13.666h1.868ZM16.336,13H14a1,1,0,0,0-1,1v2.338H1A.332.332,0,0,1,.664,16V5.711H14.012a.332.332,0,0,0,0-.664H.664V2.324A.332.332,0,0,1,1,1.992H2.125v.764a1.129,1.129,0,0,0,2.258,0V1.992H7.367v.764a1.129,1.129,0,1,0,2.258,0V1.992h2.984v.764a1.129,1.129,0,0,0,2.258,0V1.992H16a.332.332,0,0,1,.332.332Z",
    fill: "#666"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16678",
    "data-name": "Path 16678",
    d: "M110.43,238.085a.286.286,0,0,0-.406.4l2.061,2.061h-6.8a.283.283,0,0,0-.285.285.286.286,0,0,0,.285.289h6.8l-2.061,2.057a.292.292,0,0,0,0,.406.285.285,0,0,0,.406,0l2.549-2.548a.28.28,0,0,0,0-.4Z",
    transform: "translate(-101.514 -230.098)",
    fill: "#1e201d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.b59bf5beece91c217557bd41745f814c.svg";
export { ForwardRef as ReactComponent };